import axios from "axios";

import { GeoPlace } from "@/types";

interface Place {
  place_id: number;
  country?: string;
  name?: string;
  state?: string;
  city?: string;
}

export type ReverseSearchPlacesGeoRequest = {
  coordinates: [number, number];
};

export type ReverseSearchPlacesGeoResponse = Array<GeoPlace>;

export const reverseSearchPlaces = async (
  body: ReverseSearchPlacesGeoRequest
): Promise<ReverseSearchPlacesGeoResponse> => {
  const { data } = await axios<{
    features: Array<{ properties: { geocoding: Place }; geometry: Omit<GeoPlace, "label" | "optionLabel"> }>;
  }>(`https://nominatim.openstreetmap.org/reverse?lon=${body.coordinates[0]}&lat=${body.coordinates[1]}`, {
    params: {
      format: "geocodejson",
      addressdetails: 1,
      limit: 5,
      "accept-language": "en-US",
    },
  });

  const mappedPlaces = data.features.map(({ geometry, properties: { geocoding } }) => {
    const firstLvlLabel = geocoding?.name || geocoding?.city;
    const secondLvlLabel = geocoding?.state;
    const thirdLvlLabel = geocoding?.country;

    const optionLabel = [firstLvlLabel, secondLvlLabel, thirdLvlLabel].filter(Boolean).join(", ");
    const listLabel = [firstLvlLabel || secondLvlLabel, thirdLvlLabel].filter(Boolean).join(", ");

    return { value: `${geocoding.place_id}`, label: listLabel, optionLabel, coordinates: geometry.coordinates };
  });

  // removed duplicates based on the `label`
  const uniquePlaces = mappedPlaces.reduce((acc, place) => {
    if (!acc.some((existingPlace) => existingPlace.optionLabel === place.optionLabel)) {
      acc.push(place);
    }
    return acc;
  }, [] as ReverseSearchPlacesGeoResponse);

  return uniquePlaces;
};
